module.exports = "/lucky-balls/img/regular_game/check_infoBar/check_007.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/check_infoBar/check_007.png
// module id = 1131
// module chunks = 0